import React from 'react';

const DeliveryIcon = () => {
  return (
    <svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.125 20.1821V9.55713C18.125 8.52159 17.2855 7.68213 16.25 7.68213H5C3.96447 7.68213 3.125 8.52159 3.125 9.55713V18.3071C3.125 19.3427 3.96447 20.1821 5 20.1821H5.7V20.1821C5.65023 20.3602 5.625 20.5441 5.625 20.729C5.60407 21.7859 6.44317 22.6599 7.5 22.6821C8.55683 22.6599 9.39593 21.7859 9.375 20.729C9.3733 20.5442 9.34757 20.3603 9.29844 20.1821H19.3953V20.1821C19.3464 20.3592 19.3216 20.5421 19.3219 20.7259C19.3219 21.7614 20.1613 22.6009 21.1969 22.6009C22.2324 22.6009 23.0719 21.7614 23.0719 20.7259C23.0614 20.5463 23.0379 20.3677 23.0016 20.1915V20.179H25C26.0355 20.179 26.875 19.3395 26.875 18.304V14.5571L25.3125 10.1821H18.125" stroke="#333333" strokeWidth="1.6" strokeLinejoin="round"/>
    </svg>
  )
}

export default DeliveryIcon;